import styled from 'styled-components';

export const Feedback = styled.p`
  margin: 0 16px;
  color: #e71037;
  font-size: 14px;
`;

export const IneligibleMessage = styled.div`
  color: #2e3958;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.45;
  text-align: center;

  p {
    margin: 0 0 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 700;
  }
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;
